
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';
import { fetchClientData } from '../../redux/client/clientSlice';
import { useDispatch } from 'react-redux';
import api from '../../utils/api';
import socket from '../../context/socket';

const AddressProofFormModal = ({ show, onHide, proofType, kycDoc, selectedProofType, roomId }) => {
  const passportDoc = kycDoc?.find(doc => doc.doctype === "passport");
  const voteridDoc = kycDoc?.find(doc => doc.doctype === "voterid");
  const addharDoc = kycDoc?.find(doc => doc.doctype === "aadhaar");
  const selectedDoc = kycDoc?.find(doc =>
    ["passport", "aadhaar", "voterid", "dl"].includes(doc.doctype)
  );
  
  const [docData, setDocData] = useState({})
  const dispatch = useDispatch();


  useEffect(() => {
    // if (selectedProofType === "passport") {
    //   setDocData(passportDoc?.data?.[0])
    // } else if (selectedProofType === "voterid") {
    //   setDocData(voteridDoc?.data?.[0])
    // } else if (selectedProofType === "aadhaar") {
    //   setDocData(addharDoc?.data?.[0])
    // }else {
    //   setDocData({})
    // }
if(selectedDoc){
  setDocData(selectedDoc?.data?.[0])
}

  },[,selectedDoc])
  
  console.log("docData in AddressProofFormModal",selectedDoc)

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    console.log('oo23d',docData);

    if (docData) {
      setValue("fullName", docData?.name || "");
      setValue("birthDate", docData?.dob ? docData?.dob.split("T")[0] : "");
      setValue("gender", docData?.gender || "");
      setValue("city", docData?.city || "");
      setValue("state", docData?.state || "");
      setValue("pincode", docData?.pincode || "");
      setValue("address", docData?.address || "");
    }
  }, [docData, setValue]);

  const onSubmit = async (data) => {
    Swal.fire({
      text: "Please wait...",
      imageUrl: "https://www.finedge.in/assets/images/download.gif",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    const payload = {
      _id: roomId,
      name: data.fullName,
      dob: data.birthDate,
      gender: data.gender?.toUpperCase() || "",
      district: data.city, 
      city: data.city,
      state: data.state,
      pincode: data.pincode,
      address: data.address,
      uid: data.city, 
      country:"India",
      passportNumber: "xxxxxxdddddddd", 
      epicNumber: "noidsssssa",        
      document_type: selectedDoc?.doctype,
      data_status: true,
    };

    console.log("Payload:", payload);

    try {
      const response = await api.post( "advisor/add_kyc_doc_data",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response?.error) {
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response?.message,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'swal-confirm-btn',
          },
        }).then(() => {
          setValue("");
          onHide();
          dispatch(fetchClientData(roomId));
    
          socket.emit("join", { room: roomId });
          socket.emit("message_to", 
            {
              room: roomId,
              data: { message: response?.message || "Client data updated successfully",
              type: "success",}
            
            })
          console.log("emitted data message_to", roomId, "success");
        });
      }else {
        Swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: response.data?.message || 'Something went wrong!',
          confirmButtonColor: '#d33',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'API Error',
        text: error.message || 'Something went wrong during submission!',
        confirmButtonColor: '#d33',
      });
    }
  };



  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton style={{ backgroundColor: '#c7e69b' }}>
        <Modal.Title>{proofType} Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group controlId="fullName">
            <Form.Label>Full Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter full name"
              className='refer'
              {...register("fullName", { required: "Full Name is required" })}
            />
            {errors.fullName && <p className="error text-danger refer">{errors.fullName.message}</p>}
          </Form.Group>

          <Form.Group controlId="birthDate">
            <Form.Label>Birth Date</Form.Label>
            <Form.Control
              type="date"
              className='refer'
              {...register("birthDate", { required: "Birth Date is required" })}
            />
            {errors.birthDate && <p className="error text-danger">{errors.birthDate.message}</p>}
          </Form.Group>

          <Form.Group controlId="gender">
            <Form.Label>Gender</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                label="Male"
                id="gender-male"
                value="M" // ✅ value added
                {...register("gender", { required: "Gender is required" })}
                checked={watch("gender") === "M"} // ✅ condition to reflect selection
                className="refer"
              />
              <Form.Check
                inline
                type="radio"
                label="Female"
                id="gender-female"
                value="F" // ✅ value added
                {...register("gender", { required: "Gender is required" })}
                checked={watch("gender") === "F"} // ✅ condition to reflect selection
                className="refer"
              />
              {errors.gender && <p className="error text-danger">{errors.gender.message}</p>}
            </div>
          </Form.Group>


          <Form.Group controlId="city">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter city"
              {...register("city", { required: "City is required" })}
              className='refer'
            />
            {errors.city && <p className="error text-danger">{errors.city.message}</p>}
          </Form.Group>

          <Form.Group controlId="state">
            <Form.Label>State</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter state"
              {...register("state", { required: "State is required" })}
              className='refer'
            />
            {errors.state && <p className="error text-danger">{errors.state.message}</p>}
          </Form.Group>

          <Form.Group controlId="pincode">
            <Form.Label>Pincode</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter pincode"
              {...register("pincode", { required: "Pincode is required" })}
              className='refer'
            />
            {errors.pincode && <p className="error text-danger">{errors.pincode.message}</p>}
          </Form.Group>

          <Form.Group controlId="address">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter address"
              {...register("address", { required: "Address is required" })}
              className='refer'
            />
            {errors.address && <p className="error text-danger">{errors.address.message}</p>}
          </Form.Group>

          <Modal.Footer className='border-0'>
            <Button variant="secondary" onClick={onHide}>
              Close
            </Button>
            <Button variant="success" type="submit">
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddressProofFormModal;
